// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__GaLBA","type":"styles_type__1P5so","choices":"styles_choices__1V9VF"};